<template lang="html">
 <usuario-fornecedor-aprovador-autorizado-form
   v-if="tipoFornecedor === 'APROVADOR_AUTORIZADO'"
   :somente-leitura="somenteLeitura">
 </usuario-fornecedor-aprovador-autorizado-form>
</template>

<script>

import UsuarioFornecedorAprovadorAutorizadoForm from '@/spa/usuario/UsuarioFornecedorAprovadorAutorizadoForm';

export default {
  name: 'UsuarioFornecedorFormNovo',
  props: {
    somenteLeitura: Boolean,
    default: false,
  },
  components: {
    UsuarioFornecedorAprovadorAutorizadoForm,
  },
  computed: {
  },
  watch: {
  },
  data() {
    return {
      tipoFornecedor: null,
    };
  },
  methods: {
  },
  beforeMount() {
  },
  mounted() {
    this.tipoFornecedor = this.$route.params.tipoFornecedor;
  },
};
</script>
